import { Button, SelectDropDown } from '@wot/components';
import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
// import 'react-phone-number-input/style.css';
import { DEFAULT_PROFILE_PIC } from '../../../../assets/icons';
import PhoneNumberInput from '../../../../components/PhoneNumberInput/PhoneNumberInput';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { getUserByEmail, updateUser } from '../../../../reducers/userSlice';
import { API_URL } from '../../../../utils/constants';
import country from './countries.json';
import './input_field.css';
import { HorizontalTextInput } from '@wot/shared';

const countryOptions = country.map((item: any) => {
  return item.name;
});

function PersonalDetailsComponent() {
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const [, /* name */ setName] = useState<string>('');
  const [number, setNumber] = useState<string>('');
  const [phoneCount, setPhoneCount] = useState<number | null>(null);
  const [profilePic, setProfilePic] = useState<string>();
  const [selectedImage, setSelectedImage] = useState<File>();
  const [country, setCountry] = useState<string>('');
  const profilePicInput = useRef(document.createElement('input'));
  const [error /* setError */] = useState(false);
  const [emailId, setEmailId] = useState<string>('');
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.authSlice);
  const { userData } = useAppSelector((state) => state.userSlice);
  useEffect(() => {
    if (user) {
      setEmailId(user.email);
      //@ts-ignore
      dispatch(getUserByEmail(user.email));
    }
  }, [user]);

  useEffect(() => {
    if (userData) {
      setValue('name', userData?.name);
      setValue('email', userData?.email);
      setValue('area', userData?.address ? userData?.address?.area : '');
      setValue('town', userData?.address ? userData?.address?.town : '');
      setValue('state', userData?.address ? userData?.address?.state : '');
      setValue('pincode', userData?.address ? userData?.address?.pincode : '');

      setNumber(userData?.phoneNumber);
      setProfilePic(userData?.profilePic === '' ? DEFAULT_PROFILE_PIC : userData?.profilePic);
      setCountry(userData?.address ? userData?.address?.country : '');
    }
    // console.log(userData);
  }, [userData, setValue]);

  const onSave = async (data: any) => {
    if (selectedImage) {
      const formData = new FormData();
      formData.append('file', selectedImage);
      return await fetch(`${API_URL}/upload`, {
        method: 'POST',
        body: formData
      })
        .then((res) => res.json())
        .then((res) => {
          const picUrl = res.data;
          setProfilePic(picUrl);
          const user = {
            email: emailId,
            profilePic: picUrl,
            name: data.name,
            phoneNumber: number,
            address: {
              area: data.area,
              town: data.town,
              state: data.state,
              pincode: data.pincode,
              country
            }
          };
          dispatch(updateUser(user));
        });
    } else {
      const user = {
        email: emailId,
        profilePic,
        name: data.name,
        phoneNumber: number,
        address: {
          area: data.area,
          town: data.town,
          state: data.state,
          pincode: data.pincode,
          country
        }
      };
      await dispatch(updateUser(user));
    }
  };

  return (
    <div className=" w-full h-[95%] lg:px-10 px-0 overflow-hidden">
      <form
        className="relative w-full h-full mt-6 mr-32 overflow-auto"
        onSubmit={(e) => e.preventDefault()}
        encType="multipart/form-data"
      >
        <div className="container mx-auto pr-4 pb-24 h-full relative">
          <div
            className="w-max flex flex-col items-center justify-center cursor-pointer mx-auto"
            onClick={() => profilePicInput.current.click()}
          >
            {selectedImage ? (
              <div className="w-full flex flex-col items-center justify-center">
                <img
                  src={URL.createObjectURL(selectedImage)}
                  alt="Profile Pic"
                  className="h-24 w-24 object-cover rounded-full"
                />
                <p className="py-1 font-medium text-primary">Edit</p>
              </div>
            ) : profilePic ? (
              <div className="w-full flex flex-col items-center justify-center">
                <img src={profilePic} alt="Profile Pic" className="h-24 w-24 object-cover rounded-full" />
                <p className="py-1 font-medium text-primary">Edit</p>
              </div>
            ) : (
              <div className="w-full flex flex-col items-center justify-center">
                <img src={DEFAULT_PROFILE_PIC} alt="Profile Pic" className="h-24 w-24 object-cover rounded-full" />
                <p className="py-1 font-medium text-primary">Add</p>
              </div>
            )}
            <input
              type="file"
              accept="image/*"
              ref={profilePicInput}
              style={{ display: 'none' }}
              onChange={(e) => {
                // @ts-ignore
                setSelectedImage(e.target.files[0]);
              }}
            />
          </div>
          <HorizontalTextInput
            errors={errors}
            label={'Name'}
            name={'name'}
            onChange={(e: any) => setName((e.target as HTMLInputElement).value)}
            placeholder={'John Doe'}
            register={register}
            type="text"
            required={'Please enter your Name'}
          />

          <div className="py-3 flex flex-col lg:flex-row lg:items-center items-start gap-4">
            <p className="lg:w-2/5 w-full">Phone Number</p>
            <div className=" w-full flex flex-col">
              <PhoneNumberInput
                value={number}
                containerStyle={{ margin: 0 }}
                setValue={setNumber}
                setPhoneCount={setPhoneCount}
              />
              {error && (
                <p className="text-xs font-medium text-red-400">
                  {phoneCount !== number.length && 'Please Enter Correct Phone Number'}
                </p>
              )}
            </div>
          </div>

          <HorizontalTextInput
            errors={errors}
            label={'Email ID'}
            name={'email'}
            placeholder={'email@example.com'}
            register={register}
            type="email"
            disabled={true}
            required={'Please enter the Email Id'}
          />

          <div className="flex flex-col gap-4">
            <HorizontalTextInput
              errors={errors}
              label={'Area/Street'}
              name={'area'}
              placeholder={'Pahar Ganj'}
              register={register}
              type="text"
              required={'Area/Street is required'}
            />
            <HorizontalTextInput
              errors={errors}
              label={'Town/City'}
              name={'town'}
              placeholder={'New Delhi'}
              register={register}
              type="text"
              required={'Town/City is required'}
            />
            <HorizontalTextInput
              errors={errors}
              label={'State'}
              name={'state'}
              placeholder={'Delhi'}
              register={register}
              type="text"
              required={'State is required'}
            />
            <HorizontalTextInput
              errors={errors}
              label={'Pincode'}
              name={'pincode'}
              placeholder={'110001'}
              register={register}
              type="number"
              required={'Pincode is required'}
            />
          </div>
          <div className="flex flex-col lg:flex-row lg:items-center items-start gap-4 py-6">
            <p className="lg:w-2/5 w-full">Country</p>
            <div className="w-full flex flex-col">
              <SelectDropDown
                placeholder="Country"
                value={country}
                onChange={(value) => setCountry(value)}
                options={countryOptions}
                isSearchable
              />
              {error && <p className="text-xs font-medium text-red-400">{!country && 'Please Select a Country'}</p>}
            </div>
          </div>
        </div>

        <div className="absolute bottom-0 bg-white w-full py-7 flex flex-row items-center justify-center border-t">
          <div className="w-full max-w-[200px]">
            <Button block text={'Save'} onClick={handleSubmit(onSave)} role="submit" />
          </div>
        </div>
      </form>
    </div>
  );
}

export default PersonalDetailsComponent;
